var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroquetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M64,26 C83.3299662,26 99,41.7308883 99,61.1359223 C99,69.9999658 95.7303229,78.0973695 90.3356882,84.2789685 L90.8341893,103 C78.6734119,97.9872753 71.1631484,95.6569073 68.3033989,96.0088959 C66.8931541,96.1824741 65.4569735,96.2718447 64,96.2718447 C44.6700338,96.2718447 29,80.5409564 29,61.1359223 C29,41.7308883 44.6700338,26 64,26 Z M64.3338225,46.9320388 C56.2028511,46.9320388 49.6113964,53.6260338 49.6113964,61.8834951 C49.6113964,70.1409565 56.2028511,76.8349515 64.3338225,76.8349515 C72.4647938,76.8349515 79.0562485,70.1409565 79.0562485,61.8834951 C79.0562485,53.6260338 72.4647938,46.9320388 64.3338225,46.9320388 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroquetIcon);
export default __webpack_public_path__ + "static/media/croquet-icon.a09d383eb73765079ab7a9b72331a7d3.svg";
export { ForwardRef as ReactComponent };